import http from "../common/http";
import authHeader from "./header";
import { SERVICE_API_URL } from "../common/config";

const regUserRelics = (params) => {
  return http.post(SERVICE_API_URL + `/users/relics`, params, {
    headers: authHeader(),
  });
};

const userRelicFindAll = (params) => {
  return http.get(SERVICE_API_URL + `/users/relics`, {
    params: params,
    headers: authHeader(),
  });
};

export default {
  regUserRelics,
  userRelicFindAll,
};
